import { observer } from "mobx-react";
import React, { useMemo } from "react";

import { EventOffer, SportOffer } from "@gp/offer";
import {
	Corners,
	GameScore,
	HalfTimeScore,
	OvertimeScore,
	PeriodScores,
	RedCards,
	YellowCards,
} from ".";
import { PERIOD_SPORTS } from "@utils/offer/event-result/PeriodSports";
import { HALF_TIME_SPORTS } from "@utils/offer/event-result/HalfTimeSport";
import { SportAbrv } from "@utils";

export default observer(function LiveEventCurrentStats({
	event,
	sport,
}: {
	event: EventOffer;
	sport: SportOffer;
}) {
	const {
		isSoccer,
		isTennis,
		isHalfTimeSport,
		isPeriodSport,
		isQuarterSport,
	} = useMemo(
		() => ({
			isSoccer: sport?.abrv === SportAbrv.SOCCER,
			isTennis: sport?.abrv === SportAbrv.TENNIS,
			isHalfTimeSport: HALF_TIME_SPORTS.has(sport?.abrv),
			isPeriodSport: PERIOD_SPORTS.has(sport?.abrv),
			isQuarterSport: sport?.abrv === SportAbrv.BASKETBALL,
		}),
		[sport?.abrv]
	);

	const homeStats = event.result?.homeTeamTotalStatistics;
	const awayStats = event.result?.awayTeamTotalStatistics;

	return (
		<div className="event__stats">
			{isSoccer && (
				<>
					<Corners homeStats={homeStats} awayStats={awayStats} />
					<RedCards homeStats={homeStats} awayStats={awayStats} />
					<YellowCards homeStats={homeStats} awayStats={awayStats} />
				</>
			)}

			{isHalfTimeSport && event.result?.halfTimeScore && (
				<HalfTimeScore halfTimeScore={event.result.halfTimeScore} />
			)}

			{(isPeriodSport || isQuarterSport) &&
				event.result?.scorePerPeriod && (
					<PeriodScores
						scoresPerPeriod={event.result.scorePerPeriod}
					/>
				)}

			{event.result?.overTimeScore && (
				<OvertimeScore overTimeScore={event.result.overTimeScore} />
			)}

			{isTennis && <GameScore event={event} sport={sport} />}
		</div>
	);
});
